<template>
  <div class="protocol personal-authorization-info">
    <navigation v-if="!$route.query.hideTitle">个人信息授权书</navigation>
    <authorization></authorization>
    <p data-sensors-exposure-property-page_status="page_bottom" data-sensors-exposure-event-name="general_event">&nbsp;<!-- 监听协议滑动到了底部，每个协议都加上--></p>
</div></template>

<script>
export default {
  name: 'personal-authorization-info',
  data () {
    return {

    }
  },
  components: {
    authorization: () => import('@/view/protocol/components/authorization.vue')
  },
  created () {
    this.$bus.$emit('ready')
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/mixin.less";
.personal-authorization-info {
  width: 100%;
  position: relative;

  // .blue{
  //     color:#2300ff;
  // }
  // .red{
  //     color:red;
  // }
  .bolder {
    font-weight: bolder;
  }

  .text {
    text-indent: 40px;
  }

  .text:last-child {
    margin-bottom: 100px;
  }

  .tab-0 {
    text-indent: 0;
  }

  .underline:last-child {
    margin-bottom: 100px;
  }

  .baihang {
    text-align: center;
    font-size: border;
  }
}</style>
